import { t } from 'i18next';
import { Button, Typography } from '@mui/material';
import { ReactComponent as SuccessIcon } from '../../images/success.svg';

import '../../styles/DoneContainer.scss';

const DoneContainer = ({
  onClose
}) => {
  return <div className='done'>
    <div className='done-body'>
      <SuccessIcon />
      <Typography className='done-text'>{t('done.title')}</Typography>
    </div>
    <div className='done-footer'>
      <Button variant='contained' sx={{ color: '#1A1A1A', fontSize: '19px', height: '48px' }} fullWidth onClick={onClose}>{t('done.ok')}</Button>
    </div>
  </div>
}

export default DoneContainer;